import { Picture } from "~/components/ui/Picture";
import type { Flag } from "./types";

interface ProductFlagImagesProps {
  flagsToBeShown: Flag[];
}

function ProductFlagImages({ flagsToBeShown }: ProductFlagImagesProps) {
  return (
    <>
      {Array.from(new Set(flagsToBeShown.map((flag) => flag.image))).map(
        (uniqueImage, index) => {
          const flag = flagsToBeShown.find(
            (flag) => flag.image === uniqueImage,
          );
          if (!flag) return null;

          return (
            <Picture
              key={index}
              sources={[
                {
                  src: flag.image,
                  width: flag.mobile?.width ?? 24,
                  height: flag.mobile?.height ?? 24,
                  media: "(max-width: 767px)",
                },
                {
                  src: flag.image,
                  width: flag.desktop?.width ?? 24,
                  height: flag.desktop?.height ?? 24,
                  media: "(min-width: 767px)",
                },
              ]}
              src={flag.image}
              alt={flag.title}
              width={flag.desktop?.width ?? flag.mobile?.width ?? 24}
              height={flag.desktop?.height ?? flag.mobile?.height ?? 24}
              loading="lazy"
              decoding="async"
            />
          );
        },
      )}
    </>
  );
}

export default ProductFlagImages;

